t = require('app/scripts/views/internal/teacup-with-helpers')('calendar_month')

module.exports = ->
  t.table '.calendar-table'
